// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

import type { PostwsGenerativeAiAppGroupIdBrandGuidelinesSynthesisResult } from "./types";

export const isPostwsGenerativeAiAppGroupIdBrandGuidelinesSynthesisResult =
  objectOf<PostwsGenerativeAiAppGroupIdBrandGuidelinesSynthesisResult>({
    status: number,
    brand_personality: maybe(string, true),
    error: maybe(string, true),
  });
